import { render, staticRenderFns } from "./SelectTpbsVod.vue?vue&type=template&id=195a5216&"
import script from "./SelectTpbsVod.vue?vue&type=script&lang=js&"
export * from "./SelectTpbsVod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports